{
    "ReportIntervalLanguageFifteenMinutes": "15 minutos",
    "ReportIntervalLanguageThirtyMinutes": "30 minutos",
    "ReportIntervalLanguageOneHour": "1 hora",
    "ReportIntervalLanguageTwoHour": "2 horas",
    "ReportIntervalLanguageTypeMinute": "Minutos",
    "ReportIntervalLanguageTypeHour": "Hora",
    "ReportIntervalLanguageTypeHourPluralised": "Horas",
    "ReportIntervalLanguageInterpolated": "Total de chamadas por {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Chamadas por {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Chamadas por {}",
    "ReportIntervalTypeMinutes": "Minutos",
    "ReportIntervalTypeHours": "Horas",
    "ReportIntervalTypeDay": "Dia",
    "ReportIntervalTypeWeek": "Semana",
    "ReportIntervalTypeMonth": "Mês",
    "NAME": "ReportIntervalLanguage"
}